export default __webpack_public_path__ + "800ea5747e4568e8627ec3cda4bd6079.png";